import { http } from "@/lib/http";
export function fetchCampaignVideos() {
  return http.get("/api/campaignVid/get_all").then((res) => res.data);
}
export function fetchCampaignVideo(id) {
  return http.get(`/api/campaignVid/get/${id}`).then((res) => res.data);
}
export function addCampaignVideo(payload) {
  return http.post("/api/campaignVid/add", payload).then((res) => res.data);
}
export function editCampaignVideo(id, payload) {
  return http
    .post(`/api/campaignVid/edit/${id}`, payload)
    .then((res) => res.data);
}
export function deleteCampaignVideo(id) {
  return http.delete(`/api/campaignVid/delete/${id}`).then((res) => res.data);
}
